import ErpAnimatedLogo from "src/assets/animated-exonn-logo2.svg?react";
import B2bGateAnimatedLogo from "src/assets/animated-b2bgate-log.svg?react";
import type { SVGProps } from "react";
import { useClientConfig } from "src/client-config/useClientConfig.ts";
import { AppVariation } from "src/client-config/getClientConfig.ts";

export const AnimatedLogo = (props: SVGProps<SVGSVGElement>) => {
  const config = useClientConfig();
  if (
    config.appVariation === AppVariation.B2bGate ||
    config.appVariation === AppVariation.B2bGateDemo ||
    config.appVariation === AppVariation.B2bGateSupplier
  ) {
    return <B2bGateAnimatedLogo {...props} />;
  }
  return <ErpAnimatedLogo {...props} />;
};
